export default __webpack_public_path__ + "static/media/sandwich-real.ba6e5f87.png";